import React, { ReactNode } from 'react';
import { MoreVert } from '@mui/icons-material';
import { IconButton, Menu, Stack, Typography, MenuItem } from '@mui/material';

interface Props {
  renderTrigger?: (props: { onClick: (event: React.MouseEvent<HTMLElement>) => void }) => ReactNode;
  config: Array<{
    color?: string;
    label: string;
    icon?: ReactNode;
    disabled?: boolean;
    action?: VoidFunction;
  }>;
}

export const ActionsMenu = ({ config, renderTrigger }: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderTriggerElement = () => {
    if (renderTrigger) {
      return renderTrigger({ onClick: handleClick });
    }

    return (
      <IconButton color="primary" className="icon-btn-bordered" onClick={handleClick}>
        <MoreVert color="primary" />
      </IconButton>
    );
  };

  return (
    <>
      {renderTriggerElement()}

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {config
          .filter(({ action }) => typeof action === 'function')
          .map(({ label, action, disabled = false, icon, color }) => (
            <MenuItem
              key={label}
              disabled={disabled}
              onClick={() => {
                handleClose();
                action!();
              }}
            >
              <Stack direction="row" alignItems="center" gap="0.5rem">
                {icon}

                <Typography sx={{ color: color ?? '' }}>{label}</Typography>
              </Stack>
            </MenuItem>
          ))}
      </Menu>
    </>
  );
};
